import { render, staticRenderFns } from "./TheRewardScreen.vue?vue&type=template&id=2ef273be&"
import script from "./TheRewardScreen.vue?vue&type=script&lang=js&"
export * from "./TheRewardScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheRewardScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports